import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/**
 * Shows the backend's trace id for a failure, one click to copy.
 *
 * The point is that a user can paste this into a message and someone can find
 * the exact request in the log — so it has to be selectable, not decorative.
 */
export function TraceId({ id, className }: { id: string; className?: string }) {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)
  if (!id) return null
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        navigator.clipboard?.writeText(id)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      }}
      title={t('common.copyTraceId')}
      className={cn(
        'inline-flex items-center gap-1 rounded border border-current/30 px-1 font-mono text-[10px] opacity-80 hover:opacity-100',
        className,
      )}
    >
      {copied ? <Check className="size-2.5" /> : <Copy className="size-2.5" />}
      {id}
    </button>
  )
}
